<template>

<m-mobile-autocomplete
    :value="internal_value"
    :items="items"
    :search="doSearch"
    v-on:input="onInput"
    :label="label"
    placeholder="Search Conversations"
/>

</template>

<script>
const E164 = require('@/js/E164.js');
const device = require('@/js/device.js');

export default {
    props: {
        value: {
            type: [String, Object],
            default: function() { return null; },
        },
        
        label: {
            type: String,
            default: function() { return "Name"; },
        },

        organization_id: {
            type: String,
            default: function() { return null; },
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; },
        },

        'return-object' : {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            internal_value: null,
            items: [],
            search: null,
            is_loading: false, 
        }
    },

    mounted () 
    {
        if ( this.value != null && typeof this.value === 'string' )
        {
            this.setValueFromString(this.value);
            this.internal_value = null;
        }
        else
        {
            this.internal_value = this.value;
        }

        if ( this.value == null )
            this.doSearch('');
    },

    methods: {
        onInput(val) {

            if ( val == null )
            {
                this.$emit('input', null);
                this.internal_value = null;
                this.search = null;
                return;
            }

            if ( this['return-object'] )
            {
                this.$emit('input', val);
            }
            else
            {
                this.$emit('input', val.value);
            }

            this.internal_value = val;
        },

        passAllItems(item, queryText, itemText)
        {
            return true;
        },

        getOrganizationId()
        {
            if ( this.organization_id != null ) 
                return this.organization_id;

            return this.$rc.$state.organization_id;
        },

        doSearch(val)
        {
            this.is_loading = true;

            let full_text_search = val;

            let search = {
                'param_organization_id': this.getOrganizationId(),
                'full_text' : full_text_search,
                'sort' : 'conversation_label'
            };

            this.$rc.searchConversationLabels(

                search,

                (data) => {
                    this.is_loading = false;

                    this.items = data.results;

                    for ( let i = 0; i < this.items.length; i++ )
                    {
                        this.items[i].text = this.items[i].conversation_label;
                        this.items[i].value = this.items[i].conversation_id;
                    }
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }
            );
        },

        autocompleteMenuProps() {
            return device.autocompleteMenuProps();
        },

        setValueFromString(val)
        {
            if ( val == null ) return;
            if ( typeof val !== 'string' ) return;

            // assume the type is an employee id...
            
            this.is_loading = true;

            let search = {
                'param_organization_id': this.getOrganizationId(),
                'conversation_id' : val,
                'sort' : 'conversation_label'
            };

            this.$rc.searchConversationLabels(

                search,

                (data) => {
                    this.is_loading = false;

                    this.items = data.results;


                    for ( let i = 0; i < this.items.length; i++ )
                    {
                        this.items[i].text = this.items[i].conversation_label;
                        this.items[i].value = this.items[i].conversation_id;
                    }

                    if ( this.items.length == 0 )
                    {
                        this.internal_value = null;
                        this.search = null;
                        return;
                    }
                    else
                    {
                        this.internal_value = this.items[0];
                        this.search = this.items[0].text;
                    }
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }

            );
        },
    },

    watch: {
        value(val) {

            if ( val == null )
            {
                this.items = null;
                this.internal_value = null;
                this.search = null;
                return;
            }

            else if ( typeof val === 'string' )
            {
                this.setValueFromString(val);
            }

            else 
            {
                this.items=[val];
                this.internal_value = this.items[0];
                this.search = this.internal_value.text;
            }
        },

        search(val) {
            this.doSearch(val);
        }
    },
}

</script>

<style lang="scss" scoped>

</style>